import React, {useEffect, useRef} from 'react'
import {Dialog, Button} from '@startlibs/components'
import styled from 'styled-components'

const ErrorDialog = styled(Dialog) `
  max-width: 36rem;
`
const ErrorCode = styled.div `
  color: rgba(0,0,0,0.4);
  margin-top: 19px;
`

export const LoadingErrorDialog = ({closeDialog, errorCode}) => {
  return <ErrorDialog
    title="Something went wrong"
    closeDialog={closeDialog}
    auxiliarActions={<ErrorCode>Error code: {errorCode}</ErrorCode>}
    footer={<>
      <Button alert onClick={closeDialog}>Close</Button>
    </>}
  >
    <p>Please check your connection and try again.</p>
    <p>If the error persists please contact <a className="link" href="mailto:support@purview.net" target="_blank">support@purview.net</a> or <span className="nowrap">call <b>+1 800-501-1537</b>.</span></p>
  </ErrorDialog>
}